export const exampleData = {
	"online": {
		validFrom: "2025-01-15T00:00:00+01:00",
		validUntil: "2025-01-15T00:00:00+01:00",
		defaultLocation: "75625259",
		locations: {
			"75625259": {
				"title": "DRV Bund Lernwelt",
				"streetLine1": "",
				"streetLine2": "",
				"streetNumber": "",
				"zipCode": "",
				"city": ""
			}
		},
		schedule: [
			{
				"date": "2025-01-15T00:00:00+01:00",
				"slots": [
					{
						"begin": "090000",
						"end": "170000",
						"rooms": [
							{
								"short": "VLT44",
								"label": "VLT44, 60 + 2, Kamera DOZ",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_233522&client_id=weiterbildung"
							}
						]
					}
				]
			}
		],
	},
	"presence": {
		validFrom: "2025-01-20T00:00:00+01:00",
		validUntil: "2025-01-24T00:00:00+01:00",
		defaultLocation: "75933081",
		locations: {
			"75933081": {
				"title": "Victor´s Residenz-Hotel Erfurt",
				"streetLine1": "Häßlerstraße",
				"streetLine2": "",
				"streetNumber": "17",
				"zipCode": "99096",
				"city": "Erfurt"
			},
		},
		schedule: [
			{
				"date": "2025-01-20T00:00:00+01:00",
				"slots": [
					{
						"begin": "140000",
						"end": "180000",
						"rooms": []
					}
				]
			},
			{
				"date": "2025-01-21T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "163000",
						"rooms": []
					}
				]
			},
			{
				"date": "2025-01-22T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "163000",
						"rooms": []
					}
				]
			},
			{
				"date": "2025-01-23T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "163000",
						"rooms": []
					}
				]
			},
			{
				"date": "2025-01-24T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "130000",
						"rooms": []
					}
				]
			}
		],
	},
	"hybrid-external-location": {
		validFrom: "2024-11-04T00:00:00+01:00",
		validUntil: "2024-11-08T00:00:00+01:00",
		defaultLocation: "75256933",
		locations: {
			"75256933": {
				"title": "Hotel Sonnengarten",
				"streetLine1": "Adolf-Scholz-Allee",
				"streetLine2": "",
				"streetNumber": "5",
				"zipCode": "86825",
				"city": "Bad Wörishofen"
			},
			"75625259": {
				"title": "DRV Bund Lernwelt",
				"streetLine1": "",
				"streetLine2": "",
				"streetNumber": "",
				"zipCode": "",
				"city": ""
			}
		},
		schedule: [
			{
				"date": "2024-11-04T00:00:00+01:00",
				"slots": [
					{
						"begin": "140000",
						"end": "173000",
						"rooms": [
							{
								"short": "VLT10",
								"label": "VLT10, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_226059&client_id=weiterbildung"
							}
						]
					}
				]
			},
			{
				"date": "2024-11-05T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "163000",
						"rooms": [
							{
								"short": "VLT10",
								"label": "VLT10, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_226059&client_id=weiterbildung"
							}
						]
					}
				]
			},
			{
				"date": "2024-11-06T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "163000",
						"rooms": [
							{
								"short": "VLT10",
								"label": "VLT10, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_226059&client_id=weiterbildung"
							}
						]
					}
				]
			},
			{
				"date": "2024-11-07T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "163000",
						"rooms": [
							{
								"short": "VLT10",
								"label": "VLT10, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_226059&client_id=weiterbildung"
							}
						]
					}
				]
			},
			{
				"date": "2024-11-08T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "120000",
						"rooms": [
							{
								"short": "VLT10",
								"label": "VLT10, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_226059&client_id=weiterbildung"
							}
						]
					}
				]
			}
		],
	},
	"hybrid-internal-location": {
		validFrom: "2024-11-25T00:00:00+01:00",
		validUntil: "2024-11-29T00:00:00+01:00",
		defaultLocation: "75240847",
		locations: {
			"75240847": {
				"title": "Campus am Silberturm der DRV Bund",
				"streetLine1": "Hohenzollerndamm",
				"streetLine2": "",
				"streetNumber": "46-47",
				"zipCode": "10713",
				"city": "Berlin"
			},
			"75625259": {
				"title": "DRV Bund Lernwelt",
				"streetLine1": "",
				"streetLine2": "",
				"streetNumber": "",
				"zipCode": "",
				"city": ""
			}
		},
		schedule: [
			{
				"date": "2024-11-25T00:00:00+01:00",
				"slots": [
					{
						"begin": "140000",
						"end": "170000",
						"rooms": [
							{
								"short": "VLT24",
								"label": "VLT24, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_233491&client_id=weiterbildung"
							},
							{
								"short": "H 1015",
								"label": "H 1015, U-Raum, 20+1",
								"locationId": "75240847",
								"webLink": null
							}
						]
					}
				]
			},
			{
				"date": "2024-11-26T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "163000",
						"rooms": [
							{
								"short": "VLT24",
								"label": "VLT24, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_233491&client_id=weiterbildung"
							},
							{
								"short": "H 1015",
								"label": "H 1015, U-Raum, 20+1",
								"locationId": "75240847",
								"webLink": null
							}
						]
					}
				]
			},
			{
				"date": "2024-11-27T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "163000",
						"rooms": [
							{
								"short": "VLT24",
								"label": "VLT24, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_233491&client_id=weiterbildung"
							},
							{
								"short": "H 1015",
								"label": "H 1015, U-Raum, 20+1",
								"locationId": "75240847",
								"webLink": null
							}
						]
					}
				]
			},
			{
				"date": "2024-11-28T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "163000",
						"rooms": [
							{
								"short": "VLT24",
								"label": "VLT24, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_233491&client_id=weiterbildung"
							},
							{
								"short": "H 1015",
								"label": "H 1015, U-Raum, 20+1",
								"locationId": "75240847",
								"webLink": null
							}
						]
					}
				]
			},
			{
				"date": "2024-11-29T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "120000",
						"rooms": [
							{
								"short": "VLT24",
								"label": "VLT24, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_233491&client_id=weiterbildung"
							},
							{
								"short": "H 1015",
								"label": "H 1015, U-Raum, 20+1",
								"locationId": "75240847",
								"webLink": null
							}
						]
					}
				]
			}
		],
	},
	"blended-learning": {
		validFrom: "2025-02-21T00:00:00+01:00",
		validUntil: "2025-04-08T00:00:00+02:00",
		defaultLocation: "75000371",
		locations: {
			"75000371": {
				"title": "Bildungszentrum Erkner e.V.",
				"streetLine1": "Seestr.",
				"streetLine2": "",
				"streetNumber": "39",
				"zipCode": "15537",
				"city": "Erkner"
			},
			"75625259": {
				"title": "DRV Bund Lernwelt",
				"streetLine1": "",
				"streetLine2": "",
				"streetNumber": "",
				"zipCode": "",
				"city": ""
			}
		},
		schedule: [
			{
				"date": "2025-02-21T00:00:00+01:00",
				"slots": [
					{
						"begin": "090000",
						"end": "110000",
						"rooms": [
							{
								"short": "VLT04",
								"label": "VLT04, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_226054&client_id=weiterbildung"
							}
						]
					}
				]
			},
			{
				"date": "2025-03-05T00:00:00+01:00",
				"slots": [
					{
						"begin": "140000",
						"end": "173000",
						"rooms": []
					}
				]
			},
			{
				"date": "2025-03-06T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "163000",
						"rooms": []
					}
				]
			},
			{
				"date": "2025-03-07T00:00:00+01:00",
				"slots": [
					{
						"begin": "083000",
						"end": "123000",
						"rooms": []
					}
				]
			},
			{
				"date": "2025-04-08T00:00:00+02:00",
				"slots": [
					{
						"begin": "090000",
						"end": "110000",
						"rooms": [
							{
								"short": "VLT04",
								"label": "VLT04, 15 + 2, Kamera TN",
								"locationId": "75625259",
								"webLink": "https://lernwelt.drv-bund.de/goto.php?target=xmvc_226054&client_id=weiterbildung"
							}
						]
					}
				]
			}
		],
	},
	"conference": {
		validFrom: "2025-09-24T00:00:00+02:00",
		validUntil: "2025-09-26T00:00:00+02:00",
		defaultLocation: "75933082",
		locations: {
			"75933082": {
				"title": "Hotel Beckmann - Göttingen",
				"streetLine1": "Ulrideshuser Straße",
				"streetLine2": "",
				"streetNumber": "44",
				"zipCode": "37077",
				"city": "Göttingen"
			}
		},
		schedule: [
			{
				"date": "2025-09-24T00:00:00+02:00",
				"slots": [
					{
						"begin": "140000",
						"end": "173000",
						"rooms": []
					}
				]
			},
			{
				"date": "2025-09-25T00:00:00+02:00",
				"slots": [
					{
						"begin": "090000",
						"end": "170000",
						"rooms": []
					}
				]
			},
			{
				"date": "2025-09-26T00:00:00+02:00",
				"slots": [
					{
						"begin": "090000",
						"end": "123000",
						"rooms": []
					}
				]
			}
		],
	},
	"wbt": {
		validFrom: "2024-11-04T00:00:00+01:00",
		validUntil: "2024-11-08T00:00:00+01:00",
		defaultLocation: "00000000",
		locations: {
			"00000000": {
				"title": "",
				"streetLine1": "",
				"streetLine2": "",
				"streetNumber": "",
				"zipCode": "",
				"city": ""
			}
		},
		schedule: [],
	},
};

export const courseInfo = {
	"id": "1234.5678",
	"short": "1234.5678",
	"title": "Aktuelle Fragen zum Versicherungs- und Rentenrecht",
	"validFrom": "2024-06-18T00:00:00.000+01:00",
	"validUntil": "2024-06-20T00:00:00.000+01:00",
	"status": "fixiert",
	"iliasCourseLink": "https://bildung21.invorbereitung.de/goto.php?target=crs_229738&client_id=weiterbildungdev",
	"exportedAt": "2024-05-10T00:00:00.000+01:00",
	"categorization": {
		"topic": {
			"label": "Digitale Transformation, IT & Methoden",
			"color": "rgb(74, 164, 171)"
		},
		"category": {
			"label": "IT",
			"color": "rgb(74, 164, 171)",
			"iconImg": "07-informationstechnologie.png",
		},
		"subCategory": {
			"label": "Allgemeine PC-Anwendungen",
			"color": "rgb(74, 164, 171)"
		}
	},
	"contact": {
		"content": [
			{
				"fullName": "Maxi Content Muster",
				"phoneNumber": "01723456789",
				"email": "maxi.muster@drv-bund-beispiel.de",
				"image": "https://picsum.photos/400"
			}
		],
		"event": [
			{
				"fullName": "Eventvorname Nachname",
				"phoneNumber": null,
				"email": "vorname.nachname@drv-bund-beispiel.de",
				"image": null
			}
		],
		"speaker": [
			{
				"fullName": "Sasha Alberti",
				"phoneNumber": "043639698742",
				"email": "sasha.alberti@drv-bund-beispiel.de",
				"image": "https://picsum.photos/300"
			},
			{
				"fullName": "Speakervorname Nachname-Extralang",
				"phoneNumber": "",
				"email": "vorname.nachname.extralang@drv-bund-beispiel.de",
				"image": ""
			},
			{
				"fullName": "Maxi Speaker Muster",
				"phoneNumber": "01723456789",
				"email": "maxi.muster@drv-bund-beispiel.de",
				"image": "https://picsum.photos/400"
			}
		],
		"conferenceLeader": [
			{
				"fullName": "",
				"phoneNumber": "",
				"email": "",
				"image": ""
			}
		]
	},
	"defaultLocation": "472384723",
	"locations": {
		"472384723": {
			"title": "Campus am Silberturm der DRV Bund",
			"streetLine1": "Hohenzollerndamm",
			"streetNumber": "46–47",
			"streetLine2": "Eingang Nord 123",
			"zipCode": "10713",
			"city": "Berlin"
		},
		"7562525922": {
			"title": "Campus am Silberturm der DRV Bund",
			"streetLine1": "Hohenzollerndamm",
			"streetNumber": "46–47",
			"streetLine2": "",
			"zipCode": "10713",
			"city": "Berlin"
		},
		"75625259": {
			"title": "DRV Bund Lernwelt",
			"streetLine1": "Lernplattform",
			"streetLine2": "",
			"streetNumber": "",
			"zipCode": "",
			"city": "BigBlueButton"
		}
	},
	"schedule": [
		{
			"date": "2024-06-18T00:00:00.000+01:00",
			"slots": [
				{
					"begin": "080000",
					"end": "120000",
					"rooms": [
						{
							"type": "G",
							"short": "VLT15",
							"label": "VLT15, 15 + 2, Kamera TN",
							"locationId": "75625259",
							"webLink": "https://lernwelt.drv-bund.de/mein/weg/zum/raum"
						}
					]
				},
				{
					"begin": "130000",
					"end": "160000",
					"rooms": [
						{
							"type": "P",
							"short": "H0043",
							"label": "Hörsaal 1, H0043",
							"locationId": "472384723",
							"webLink": null
						}
					]
				}
			]
		},
		{
			"date": "2024-06-19T00:00:00.000+01:00",
			"slots": [
				{
					"begin": "080000",
					"end": "110000",
					"rooms": [
						{
							"type": "P",
							"short": "H0043",
							"label": "Hörsaal 1, H0043",
							"locationId": "472384723",
							"webLink": null
						}
					]
				},
				{
					"begin": "111500",
					"end": "123000",
					"rooms": [
						{
							"type": "G",
							"short": "VLT15",
							"label": "VLT15, 15 + 2, Kamera TN",
							"locationId": "75625259",
							"webLink": "https://lernwelt.drv-bund.de/mein/weg/zum/raum"
						}
					]
				},
				{
					"begin": "133000",
					"end": "160000",
					"rooms": [
						{
							"type": "P",
							"short": "H0043",
							"label": "Hörsaal 1, H0043",
							"locationId": "472384723",
							"webLink": null
						}
					]
				}
			]
		},
		{
			"date": "2024-06-20T00:00:00.000+01:00",
			"slots": [
				{
					"begin": "080000",
					"end": "120000",
					"rooms": [
						{
							"type": "G",
							"short": "VLT15",
							"label": "VLT15, 15 + 2, Kamera TN",
							"locationId": "75625259",
							"webLink": "https://lernwelt.drv-bund.de/mein/weg/zum/raum"
						}
					],
				},
				{
					"begin": "130000",
					"end": "160000",
					"rooms": [
						{
							"type": "P",
							"short": "H0043",
							"label": "Hörsaal 1, H0043",
							"locationId": "472384723",
							"webLink": null
						}
					]
				}
			]
		}
	],
	"notes": [
		"Dies ist ein Typoblindtext.",
		"An ihm kann man sehen, ob alle Buchstaben da sind und wie sie aussehen.",
		"Manchmal benutzt man Worte wie Hamburgefonts,",
		"Rafgenduks oder Handgloves, um Schriften zu testen.",
		"Manchmal Sätze, die alle Buchstaben des Alphabets enthalten -",
		"man nennt diese Sätze »Pangrams«."
	],
	"importantInfo": [
		[
			"Genauso wichtig sind mittlerweile auch Âçcèñtë,",
			"die in neueren Schriften aber fast immer enthalten sind."
		],
		[
			"In Lateinisch sieht zum Beispiel fast jede Schrift gut aus.",
			"Quod erat demonstrandum."
		],
		[
			"Oft werden in Typoblindtexte auch fremdsprachige Satzteile eingebaut",
			"(AVAIL® and Wefox™ are testing aussi la Kerning), um die Wirkung in anderen Sprachen zu testen."
		]
	],
	"courseContents": [
		{
			"title": "My folder",
			"description": "",
			"link": "http://ilias.localhost/?folder=1",
			"icon": "http://ilias.localhost/Customizing/global/skin/drv-bund/images/icon_fold.svg"
		},
		{
			"title": "My folder",
			"description": "My folder with nice content",
			"link": "http://ilias.localhost/?folder=2",
			"icon": "http://ilias.localhost/Customizing/global/skin/drv-bund/images/icon_fold.svg"
		},
		{
			"title": "My folder",
			"description": "",
			"link": "http://ilias.localhost/?folder=3",
			"icon": "http://ilias.localhost/Customizing/global/skin/drv-bund/images/icon_fold.svg"
		},
		{
			"title": "My folder",
			"description": "My folder with nice content",
			"link": "http://ilias.localhost/?folder=4",
			"icon": "http://ilias.localhost/Customizing/global/skin/drv-bund/images/icon_fold.svg"
		},
		{
			"title": "My folder",
			"description": "",
			"link": "http://ilias.localhost/?folder=5",
			"icon": "http://ilias.localhost/Customizing/global/skin/drv-bund/images/icon_fold.svg"
		},
		{
			"title": "My folder",
			"description": "My folder with nice content",
			"link": "http://ilias.localhost/?folder=6",
			"icon": "http://ilias.localhost/Customizing/global/skin/drv-bund/images/icon_fold.svg"
		},
		{
			"title": "My folder",
			"description": "",
			"link": "http://ilias.localhost/?folder=7",
			"icon": "http://ilias.localhost/Customizing/global/skin/drv-bund/images/icon_fold.svg"
		},
		{
			"title": "My folder",
			"description": "My folder with nice content",
			"link": "http://ilias.localhost/?folder=8",
			"icon": "http://ilias.localhost/Customizing/global/skin/drv-bund/images/icon_fold.svg"
		},
		{
			"title": "My folder",
			"description": "My folder with nice content",
			"link": "http://ilias.localhost/?folder=9",
			"icon": "http://ilias.localhost/Customizing/global/skin/drv-bund/images/icon_fold.svg"
		},
		{
			"title": "My folder",
			"description": "My folder with nice content",
			"link": "http://ilias.localhost/?folder=10",
			"icon": "http://ilias.localhost/Customizing/global/skin/drv-bund/images/icon_fold.svg"
		},
		{
			"title": "My folder",
			"description": "My folder with nice content",
			"link": "http://ilias.localhost/?folder=11",
			"icon": "http://ilias.localhost/Customizing/global/skin/drv-bund/images/icon_fold.svg"
		}
	],
}
